import * as React from 'react';
import * as styles from './text.css';

import { mergeStyles } from '@cian/utils';

export type TTextSize = 'base' | 'promo' | 'small' | 'huge' | 'h1' | 'h2' | 'h3';
export type TColor = 'black' | 'orange' | 'blue' | 'gray';

export interface ITextProps {
  textSize?: TTextSize;
  color?: TColor;
  bold?: boolean;
  children?: React.ReactNode;
}

export function Text({ children, textSize = 'base', bold, color, ...rest }: ITextProps) {
  return (
    <span {...rest} {...mergeStyles(styles[textSize], bold && styles['bold'], color && styles[color])}>
      {children}
    </span>
  );
}
